import { CurrencyType, DictFilterInput, requestsClient } from '@/shared/api';

import { ICurrenciesQueryParams } from '../types';

export const currenciesQuery = async ({
  search = '',
  tickers,
  type,
}: ICurrenciesQueryParams = {}) => {
  const input: DictFilterInput = {
    type: CurrencyType.Fiat,
    tags: ['for_fiat_account'],
  };
  if (type) input.type = type;
  if (search.trim()) input.itemQuery = search;
  if (tickers?.length) input.tickers = tickers;

  const { currencies } = await requestsClient.currencies({
    input,
  });
  return currencies;
};

export const paginationCurrenciesQuery = async ({
  search = '',
}: ICurrenciesQueryParams) => {
  const response = await currenciesQuery({ search });
  return {
    count: response.length,
    cursor: response.length,
    nodes: response,
  };
};
